<template>
  <!-- <Card> -->
  <!-- {{ tradingBankList }} -->
  <!-- <p slot="title">黑市</p> -->
  <div>

    <Input v-model="bussinessName" @input="getTradingBankList()" placeholder="商品名称" clearable style="margin-bottom:20px;width: 80%" />
    <Button style="float: right;line-height: 30px;height: 30px" @click="getTradingBankList()" size="small" >
      获取
    </Button>
    <div class="parent1">
      <div style=" border: 1px solid #abb6c0;"  :class="'ddiv'+(index+1)" v-for="(item, index) in tradingBankList" :key="index">
        <span style="padding: 0px 10px" :style="{ color: distinguishColor(item.color) }" >{{ item.busName }}</span><br>
        <span style="padding: 0px 10px;color:#1890ff ">数量：{{ item.goodNum }}</span><br>
        <span style="padding: 0px 10px">卖家：{{ item.sellerName }}</span><br>
        <span style="color:#ff8c00;height: 30px;line-height:30px;padding: 0px 10px"><Icon type="ios-pricetags-outline" /> {{ item.price }}</span>
        <Button @click.prevent="purchase(item)" size="small" >
          购买
        </Button>
      </div>
    </div>
<!--    <div class="parent1">
      <Poptip trigger="hover" style=" border: 1px solid #abb6c0;" :class="'ddiv'+(index+1)" v-for="(item, index) in tradingBankList" :key="index" :title="item.name">
        <p style="white-space: nowrap;padding: 0px 10px" :style="{ color: distinguishColor(item.color) }">
          {{ item.busName }}<br>   </p>
          <span style="padding: 0px 10px">交易数量： {{ item.goodNum }}</span><br>
          <span style="padding: 0px 10px">售卖人： {{ item.sellerName }}</span><br>
          <span style=" height: 30px;line-height:30px;padding: 0px 10px"><Icon type="ios-pricetags-outline" /> {{ item.price }}</span>
          <Button @click.prevent="purchase(item)" size="small" >
            购买
          </Button>
&lt;!&ndash;        <div slot="content" class="poptipExplain">
          <div></div>
          <div class="Equipment">
            <p :style="{ color: distinguishColor(item.color) }">
              {{ item.busName }}
            </p>
            <p>交易状态 {{ item.busStatus }}</p>
            <p>售卖时间 {{ item.saleTime }}</p>
            <p>售价 {{ item.price }}</p>
            <Divider v-if="item.sellerName" />
            <p v-if="item.sellerName">描述： {{ item.sellerName }}</p>
          </div>
        </div>&ndash;&gt;
      </Poptip>
    </div>-->

    <Page :total="total" :page-size="pageSize" @on-change="changepage"></Page>
  </div>
  <!-- </Card> -->
</template>

<script>
export default {
  name: "tradingBank",
  data() {
    return {
      tradingBankList: [],
      bussinessName: '',
      pageSize: 20,
      total: 0
    };
  },
  created() {
    setInterval(() => {
      this.getTradingBankList();
    }, 10000000);
  },
  methods: {
    // 返回品质颜色
    distinguishColor(color) {
      if (color == 1) {
        return "#000";
      } else if (color == 2) {
        return "#c5c52f";
      } else if (color == 3) {
        return "green";
      } else if (color == 4) {
        return "#1890ff";
      } else if (color == 5) {
        return "purple";
      } else if (color == 6) {
        return "red";
      } else if (color == 7) {
        return "#ff8c00";
      } else {
        return "#ff00c3e0";
      }
    },
    getTradingBankList(index = 1) {
      this.$http.post("gameBussiness/getBussinessList?page=" + index + "&pageSize=" + this.pageSize + '&bussinessName=' + this.bussinessName).then((res) => {
        console.error(res.data.rows)
        this.tradingBankList = res.data.rows;
        this.total = res.data.records
      }).catch((err) => {
        this.$Notice.warning({title:"获取黑市失败,请联系管理员"});
      });
    },
    changepage(index) {
      this.getTradingBankList(index)
    },
    pageSizeChange(index) {
      console.error(index)
      this.getTradingBankList()
    },
    purchase(item) {
      this.$http.post(
        "/gameBussiness/playersBuyItem/?charaId=" +
        this.getCookie("charaId") +
        "&buyId=" +
        item.busId
      )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});

        })
        .catch((err) => {
          this.$Notice.warning({title:"购买失败,请联系管理员"});
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.knapsack > div {
  margin-right: 20px;
  margin-bottom: 20px;
}

.Equipment p {
  color: #8b78e6;
}
.parent1 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
/*.parent1 div:hover{
  border: 2px solid #88DD11 !important;
}*/
.ddiv1 { grid-area: 1 / 1 / 2 / 2; }
.ddiv2 { grid-area: 1 / 2 / 2 / 3; }
.ddiv3 { grid-area: 1 / 3 / 2 / 4; }
.ddiv4 { grid-area: 1 / 4 / 2 / 5; }
.ddiv5 { grid-area: 2 / 1 / 3 / 2; }
.ddiv6 { grid-area: 2 / 2 / 3 / 3; }
.ddiv7 { grid-area: 2 / 3 / 3 / 4; }
.ddiv8 { grid-area: 2 / 4 / 3 / 5; }
.ddiv9 { grid-area: 3 / 1 / 4 / 2; }
.ddiv10 { grid-area: 3 / 2 / 4 / 3; }
.ddiv11 { grid-area: 3 / 3 / 4 / 4; }
.ddiv12 { grid-area: 3 / 4 / 4 / 5; }
.ddiv13 { grid-area: 4 / 1 / 5 / 2; }
.ddiv14 { grid-area: 4 / 2 / 5 / 3; }
.ddiv15 { grid-area: 4 / 3 / 5 / 4; }
.ddiv16 { grid-area: 4 / 4 / 5 / 5; }
.ddiv17 { grid-area: 5 / 1 / 6 / 2; }
.ddiv18 { grid-area: 5 / 2 / 6 / 3; }
.ddiv19 { grid-area: 5 / 3 / 6 / 4; }
.ddiv20 { grid-area: 5 / 4 / 6 / 5; }
</style>




// WEBPACK FOOTER //
// src/components/tradingBank.vue